import axios from "axios";
import { TokenTransactionActions } from "./tokenTransactionAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all Virtual Token api
export const getAllTokenTransactionAsync = (search, searchText) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let {
        skip,
        limit,
        status,
        transaction_type,
        searchText,
        fromDate,
        toDate,
      } = getState().tokenTransaction;
      dispatch(TokenTransactionActions.getAllTokenTransactionStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/getAllTokenTransaction`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          search: searchText,
          skip,
          limit,
          status: status?.value,
          transaction_type: transaction_type?.value,
          fromDate,
          toDate,
        },
      });
      if (data.statusCode === 200) {
        return dispatch(
          TokenTransactionActions.getAllTokenTransactionSuccess(data)
        );
      }
      dispatch(TokenTransactionActions.getAllTokenTransactionError());
    } catch (error) {
      dispatch(TokenTransactionActions.getAllTokenTransactionError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

export const getTokenTransactionAsync = (transactionId) => {
  return async (dispatch) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const token = process.env.REACT_APP_AUTH_TOKEN; // Replace with the actual token logic

      dispatch(TokenTransactionActions.getTokenTransactionStart());

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/getTokenTransaction/${transactionId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (data.statusCode === 200) {
        return dispatch(
          TokenTransactionActions.getTokenTransactionSuccess(data)
        );
      }

      dispatch(TokenTransactionActions.getTokenTransactionError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Failed to fetch transaction details",
          3000
        )
      );
    } catch (error) {
      dispatch(TokenTransactionActions.getTokenTransactionError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while fetching transaction details",
          3000
        )
      );
    }
  };
};

// Add token transaction API
export const addTokenTransactionAsync = (values) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(TokenTransactionActions.addTokenTransactionStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokenTransactions/adminCreditTokenTransaction`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.statusCode === 200 || data.statusCode === 201) {
        dispatch(TokenTransactionActions.addTokenTransactionSuccess(data));
        return dispatch(
          showSuccessSnackbar("success", "Token added successfully!", 3000)
        );
      }
      dispatch(TokenTransactionActions.addTokenTransactionError());
      return dispatch(
        showSuccessSnackbar(
          "error",
          data.responseMessage || "Error adding token",
          3000
        )
      );
    } catch (error) {
      dispatch(TokenTransactionActions.addTokenTransactionError());
      dispatch(
        showSuccessSnackbar(
          "error",
          "Error while adding token. Please try again later",
          3000
        )
      );
    }
  };
};
//update Token transaction api
export const updateTokenTransactionAsync = (values, transaction_id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(TokenTransactionActions.updateTokenTransactionStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/editTokenTransaction/${transaction_id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.statusCode === 200 || data.statusCode === 201) {
        dispatch(TokenTransactionActions.updateTokenTransactionSuccess(data));
        return dispatch(
          showSuccessSnackbar(
            "success",
            "Withdrawal Status Updated Successfully",
            3000
          )
        );
      }
      dispatch(TokenTransactionActions.updateTokenTransactionError());
      return dispatch(showSuccessSnackbar("error", data.data, 3000));
    } catch (error) {
      dispatch(TokenTransactionActions.updateTokenTransactionError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
// //delete Virtual Token api
// export const deleteTokenTransactionAsync = (id) => {
//   return async (dispatch, getState) => {
//     try {
//       const adminBaseURL = process.env.REACT_APP_BASE_URL;

//       dispatch(TokenTransactionActions.deleteTokenTransactionStart());
//       const { data } = await axios({
//         method: "DELETE",
//         url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/deleteTokenTransaction/${id}`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       if (data.statusCode === 200) {
//         dispatch(TokenTransactionActions.deleteTokenTransactionSuccess(data));
//         return dispatch(
//           showSuccessSnackbar(
//             "success",
//             "Virtual Token Deleted Successfully",
//             3000
//           )
//         );
//       }
//       dispatch(TokenTransactionActions.deleteTokenTransactionError());

//       return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
//     } catch (error) {
//       dispatch(TokenTransactionActions.deleteTokenTransactionError(error));
//       dispatch(showSuccessSnackbar("error", error.data.message, 3000));
//     }
//   };
// };
